import { render, staticRenderFns } from "./GroupSide.vue?vue&type=template&id=d82db3d4&scoped=true&"
import script from "./GroupSide.vue?vue&type=script&lang=js&"
export * from "./GroupSide.vue?vue&type=script&lang=js&"
import style0 from "./GroupSide.vue?vue&type=style&index=0&id=d82db3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82db3d4",
  null
  
)

export default component.exports